
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate/[_name]",
      function () {
        return require("private-next-pages/real-estate/[_name].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate/[_name]"])
      });
    }
  